function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classnames from 'classnames';
import { Flex, Popup } from '@leverege/ui-elements';
import S from './Selector.css';
const dIsSelected = (v, value) => {
  return v && (value === undefined ? v.active === true : v.value === value);
};
const dGetName = v => {
  return v && v.name;
};
const dGetRenderer = (v, name) => {
  return /*#__PURE__*/React.createElement("div", {
    className: S.renderer
  }, name);
};
const dGetCheckRenderer = selected => {
  return /*#__PURE__*/React.createElement("i", {
    className: classnames('fa fa-check', S.check, selected && S.selected)
  });
};
export default class Selector extends React.Component {
  onSelect = evt => {
    const {
      onChange,
      eventData
    } = this.props;
    if (onChange) {
      onChange({
        value: evt.value,
        data: eventData
      });
    }
  };
  render() {
    const {
      values,
      eventData,
      value,
      isSelected = dIsSelected,
      renderer = dGetRenderer,
      valueName = dGetName,
      checkRenderer = dGetCheckRenderer,
      onChange,
      // ignore
      title,
      ...rest
    } = this.props;
    if (values == null) {
      return null;
    }
    const cValue = values.find(item => {
      return item.value === value;
    });
    const name = cValue && cValue.name || '';
    return /*#__PURE__*/React.createElement(Popup, _extends({
      title: title || name
    }, rest), values.map((v, index) => {
      const selected = isSelected(v, value);
      const check = checkRenderer(selected);
      const name = valueName(v);
      const view = renderer(v, name);
      return /*#__PURE__*/React.createElement(Popup.Item, {
        key: `Item-${name}`,
        value: v.value,
        onClick: this.onSelect
      }, /*#__PURE__*/React.createElement(Flex, {
        variant: "noSpace"
      }, check, view));
    }));
  }
}